export enum ClassNames {
  IsTabbing = 'is-tabbing'
}
